var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhotoRejectedM(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "30px",
    viewBox: "0 0 35 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPhotoRejectedM") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.7564217,26.3975017 L20.2563653,1.59004423 C19.8623553,0.963080387 19.1549141,0.579710145 18.3918104,0.579710145 C17.6287067,0.579710145 16.9212656,0.963013795 16.5272556,1.59004423 L0.937036951,26.3975017 C0.531575222,27.0427118 0.519568224,27.8474763 0.905735472,28.5034743 C1.29190272,29.1595388 2.01627863,29.5652174 2.80152238,29.5652174 L31.8918669,29.5652174 C32.6771106,29.5652174 33.4014865,29.1594722 33.7876538,28.5034743 C34.173821,27.8474097 34.1618834,27.0427118 33.7564217,26.3975017 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Manage-Photos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPhotoRejectedM"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FF0000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9155955,9.49832776 C18.8151881,9.49832776 19.5763657,9.97553759 19.5763657,10.8213753 C19.5763657,13.4023605 19.2534439,17.111326 19.2534439,19.6923113 C19.2534439,20.3647194 18.4691856,20.6465998 17.9155955,20.6465998 C17.1775684,20.6465998 16.554736,20.3646539 16.554736,19.6923113 C16.554736,17.111326 16.2318841,13.4023605 16.2318841,10.8213753 C16.2318841,9.97553759 16.9699111,9.49832776 17.9155955,9.49832776 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9150614,25.1059086 C16.9533024,25.1059086 16.2318841,24.3240851 16.2318841,23.4336678 C16.2318841,22.5215185 16.9532364,21.761427 17.9150614,21.761427 C18.811267,21.761427 19.5763657,22.5215185 19.5763657,23.4336678 C19.5763657,24.3240851 18.811267,25.1059086 17.9150614,25.1059086 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhotoRejectedM);
export default __webpack_public_path__ + "static/media/icPhotoRejectedM.13ac702c46d364ddb6b0e4d05ddea180.svg";
export { ForwardRef as ReactComponent };